export default __webpack_public_path__ + "img/digital_atelier_256x256_black.ded3f8b9.png";